import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNumber3Solid = function SvgNumber3Solid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 15 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M7.576 19.372c4.423 0 7.271-2.24 7.271-5.42 0-2.764-2.433-4.23-4.313-4.423 2.046-.36 4.037-1.88 4.037-4.202 0-3.07-2.655-5.005-6.968-5.005-2.516 0-4.479.774-5.972 1.936-.387.304-.663.774-.663 1.3 0 .884.746 1.63 1.631 1.63.332 0 .636-.11.885-.276C4.617 4.138 5.86 3.75 7.189 3.75c1.935 0 3.428.746 3.428 2.211 0 1.383-1.355 2.046-3.4 2.046h-.803c-.912 0-1.686.747-1.686 1.66 0 .967.774 1.714 1.714 1.714h.774c2.571 0 3.705.69 3.705 2.184 0 1.41-1.244 2.377-3.484 2.377A7.36 7.36 0 0 1 3.401 14.7a1.64 1.64 0 0 0-.913-.304c-.967 0-1.741.774-1.741 1.714 0 .553.304 1.078.718 1.383 1.493 1.133 3.567 1.88 6.11 1.88",
        clipRule: "evenodd"
    })));
};

export { SvgNumber3Solid as ReactComponent };
//# sourceMappingURL=Number3Solid.svg.es.js.map
